import { Project } from './project'

export class Note {
  _text: string
  isNew: boolean


  constructor(
    public id: string,
    public parentId: string,
    public project: Project,
    text: string,
    public date: Date,
    public creator: string
  ) {
    this.text = text
    this.isNew = this._text == ''
    let nm = project.notesMap.get(this.parentId)
    if (!nm) {
      nm = new Map<string, Note>()
      project.notesMap.set(this.parentId, nm)
    }
    nm.set(this.creator, this)
  }


  set text(txt) {
    txt = txt || ''
    this._text = txt.trim()
  }

  get text() {
    return this._text
  }

  get saveParams() {
    return {
      fun:'saveNote',
      id: this.id,
      projectId: this.project.id,
      parentId: this.parentId,
      text: this.text,
      date: this.date.toJSON()
    }
  }

  get deleteParams() {
    return {
      fun:'deleteNote',
      id: this.id,
      projectId: this.project.id
    }
  }

}



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/note.ts